export const FIRST_DANCE_TRACKER_EN = '<FirstDanceTrackerEN>';
export const FIRST_DANCE_TRACKER_DE = '<FirstDanceTrackerDE>';

export const FIRST_DANCE_TRACKER_SRC: Record<string, string> = {
  [FIRST_DANCE_TRACKER_EN]: '/articles/first-dance-tracker/uk.html',
  [FIRST_DANCE_TRACKER_DE]: '/articles/first-dance-tracker/de.html',
};
